"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyTypeObject$ = exports.PropertyTypeObject$outboundSchema = exports.PropertyTypeObject$inboundSchema = void 0;
exports.propertyTypeObjectToJSON = propertyTypeObjectToJSON;
exports.propertyTypeObjectFromJSON = propertyTypeObjectFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const meta_js_1 = require("./meta.js");
const propertytype_js_1 = require("./propertytype.js");
/** @internal */
exports.PropertyTypeObject$inboundSchema = z.object({
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    value: z.nullable(propertytype_js_1.PropertyType$inboundSchema),
});
/** @internal */
exports.PropertyTypeObject$outboundSchema = z.object({
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    value: z.nullable(propertytype_js_1.PropertyType$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyTypeObject$;
(function (PropertyTypeObject$) {
    /** @deprecated use `PropertyTypeObject$inboundSchema` instead. */
    PropertyTypeObject$.inboundSchema = exports.PropertyTypeObject$inboundSchema;
    /** @deprecated use `PropertyTypeObject$outboundSchema` instead. */
    PropertyTypeObject$.outboundSchema = exports.PropertyTypeObject$outboundSchema;
})(PropertyTypeObject$ || (exports.PropertyTypeObject$ = PropertyTypeObject$ = {}));
function propertyTypeObjectToJSON(propertyTypeObject) {
    return JSON.stringify(exports.PropertyTypeObject$outboundSchema.parse(propertyTypeObject));
}
function propertyTypeObjectFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyTypeObject$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyTypeObject' from JSON`);
}
//# sourceMappingURL=propertytypeobject.js.map